import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import NotificationsBanner from "@/components/NotificationsBanner";
import Home from "@/pages/Home";
import Fleet from "@/pages/Fleet";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import AccountSettings from "@/pages/AccountSettings";
import Book from "@/pages/Book";
import ManageBooking from "@/pages/ManageBooking";
import NotFound from "@/pages/NotFound";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DriverLogin from "@/pages/driver/DriverLogin";
import DriverDashboard from "@/pages/driver/DriverDashboard";
import DriverRunDetail from "@/pages/driver/DriverRunDetail";
import AdminLayout from "@/components/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminDispatch from "@/pages/admin/AdminDispatch";
import AdminBookings from "@/pages/admin/AdminBookings";
import AdminFleet from "@/pages/admin/AdminFleet";
import AdminPricing from "@/pages/admin/AdminPricing";
import PricingReports from "@/pages/admin/PricingReports";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminComplaints from "@/pages/admin/AdminComplaints";
import AdminDocumentation from "@/pages/admin/AdminDocumentation";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <NotificationsProvider>
          <BrowserRouter>
            <NotificationsBanner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/fleet" element={<Fleet />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/book" element={<Book />} />
              <Route path="/booking/:id" element={<ManageBooking />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/account" element={<Account />} />
              <Route path="/account/settings" element={<AccountSettings />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/driver/login" element={<DriverLogin />} />
              <Route path="/driver" element={<DriverDashboard />} />
              <Route path="/driver/settings" element={<AccountSettings />} />
              <Route path="/driver/runs/:id" element={<DriverRunDetail />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="dispatch" element={<AdminDispatch />} />
                <Route path="bookings" element={<AdminBookings />} />
                <Route path="fleet" element={<AdminFleet />} />
                <Route path="pricing" element={<AdminPricing />} />
                <Route path="pricing-reports" element={<PricingReports />} />
                <Route path="users" element={<AdminUsers />} />
                <Route path="complaints" element={<AdminComplaints />} />
                <Route path="documentation" element={<AdminDocumentation />} />
                <Route path="settings" element={<AdminSettings />} />
              </Route>
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Toaster theme="dark" position="top-right" toastOptions={{ style: { background: "#121214", border: "1px solid rgba(255,255,255,0.1)", color: "#E6E6E6" } }} />
          </BrowserRouter>
        </NotificationsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
